<mat-card style="box-shadow:none;    padding: 0px !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
      <span mat-card-avatar>
        <mat-icon>question_answer</mat-icon>
      </span>
      <mat-card-title>Shipment Update frequency</mat-card-title>
    </mat-card-header>
    <div>
        <p>Please select one of the following options for the update logic :</p>
        <p>Current tracking frequency: {{trackingFrequency}}</p>
    </div>
    <div>
        <mat-form-field style="width: 45% !important;">
            <label>Frequency Update Type</label>
            <select matNativeControl [(ngModel)]="frequencyUpdateType">
                <option [value]="null">-- Select --</option>
                <option *ngFor="let option of frequencyUpdateTypes" [value]="option.id">
                    <span style="padding:5px !important;"> {{ option.name }} </span>
                </option>
            </select>
        </mat-form-field>
    </div>
    <mat-divider></mat-divider>
    <div class="mat-card-actions-container">
      <mat-card-actions>
        <div fxLayout="row">
          <span fxFlex></span>
          <button type="button" mat-raised-button (click)="back()" class="text-upper">Cancel</button>
          <button mat-raised-button (click)="save()"
            color="accent"
            class="text-upper">Save</button>
        </div>
      </mat-card-actions>
    </div>
</mat-card>
